import { Link } from "react-router-dom";
import { HERO_IMAGE, TRIP } from "@/data/content";
import { ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section data-testid="hero-section" className="relative h-[92vh] min-h-[640px] max-h-[920px] w-full overflow-hidden">
      <img
        src={HERO_IMAGE}
        alt="Pilgrims performing tawaf around the Ka'bah in Makkah"
        width="1920"
        height="1200"
        loading="eager"
        fetchPriority="high"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 hero-overlay-strong" />
      <div className="absolute inset-0 grain pointer-events-none" />

      <div className="relative h-full max-w-7xl mx-auto px-5 md:px-8 flex flex-col justify-end pb-16 md:pb-24">
        <div className="max-w-2xl fade-up">
          <span className="overline text-gold">Umrah · Knowledge · Community</span>
        </div>
        <h1 className="mt-4 font-serif text-white text-[40px] leading-[1.05] md:text-6xl lg:text-7xl tracking-tight max-w-3xl fade-up delay-1">
          Experience Umrah With Knowledge, Community &amp; Guidance
        </h1>
        <p className="mt-6 text-white/85 text-base md:text-lg max-w-2xl leading-relaxed fade-up delay-2">
          Guided group Umrah experiences with education, support, premium accommodations,
          historical tours, and community from departure to return.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 fade-up delay-3">
          <Link
            to="/umrah-october-2026"
            data-testid="hero-view-trip-btn"
            className="btn-gold rounded-full px-6 py-3 font-semibold inline-flex items-center justify-center gap-2"
          >
            View {TRIP.title} <ArrowRight size={18} />
          </Link>
          <Link
            to="/contact"
            data-testid="hero-register-btn"
            className="rounded-full px-6 py-3 font-semibold border border-white/60 text-white hover:bg-white hover:text-navy transition-colors inline-flex items-center justify-center"
          >
            Register Interest
          </Link>
        </div>
      </div>
    </section>
  );
}
